<template>
    <div class="settings-users-page" :class="{ 'settings-users-page--embedded': embedded }">
        <div v-if="!embedded" class="settings-users-page__heading">子账号管理</div>
        <div v-if="!hideToolbar" class="settings-users-page__toolbar">
            <el-button v-if="!hideCreateButton" type="primary" size="small" icon="el-icon-plus" @click="openCreateDialog">新增子账号</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
        </div>
        <el-card v-loading="loading" shadow="never" class="settings-users-page__card">
            <el-table :data="users" border stripe>
                <el-table-column prop="name" label="姓名" min-width="100" align="center" header-align="center" />
                <el-table-column prop="username" label="登录名" min-width="120" align="center" header-align="center" />
                <el-table-column prop="phone" label="手机号" min-width="120" align="center" header-align="center" />
                <el-table-column label="超级管理员" width="110" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        {{ row.is_super_admin ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="80" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        {{ row.status === 1 ? '正常' : '停用' }}
                    </template>
                </el-table-column>
                <el-table-column label="角色" min-width="180" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        {{ formatRoles(row.roles) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="260" fixed="right" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        <template v-if="row.is_super_admin">
                            <el-button type="text" size="small" @click="openSuperAdminEditDialog(row)">修改</el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="small" @click="openEditDialog(row)">编辑</el-button>
                            <el-button type="text" size="small" @click="openRoleDialog(row)">分配角色</el-button>
                            <el-button type="text" size="small" @click="toggleUserStatus(row)">
                                {{ row.status === 1 ? '停用' : '启用' }}
                            </el-button>
                            <el-button type="text" size="small" class="settings-users-page__danger" @click="removeUser(row)">
                                删除
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog
            :title="editingUserId ? '编辑子账号' : '新增子账号'"
            :visible.sync="userDialogVisible"
            width="560px"
            :close-on-click-modal="false"
            @closed="resetUserForm"
        >
            <el-form ref="userFormRef" :model="userForm" :rules="userRules" label-width="100px">
                <el-form-item v-if="!editingUserId" label="角色类型" prop="roleTypeCode" required>
                    <el-select
                        v-model="userForm.roleTypeCode"
                        placeholder="请选择角色类型"
                        filterable
                        style="width: 100%"
                        @change="onRoleTypeCodeChange"
                    >
                        <el-option
                            v-for="opt in roleTypeOptions"
                            :key="opt.value"
                            :label="opt.label"
                            :value="opt.value"
                        />
                    </el-select>
                </el-form-item>
                <!-- 新增 + 渠道专员：渠道名称 → 登录名 → 姓名 → … -->
                <template v-if="isChannelSpecialistCreate">
                    <el-form-item label="渠道名称" prop="channelName" required>
                        <el-input v-model.trim="userForm.channelName" maxlength="150" placeholder="请输入渠道名称" />
                    </el-form-item>
                    <el-form-item label="登录名" prop="username">
                        <el-input
                            v-model.trim="userForm.username"
                            maxlength="50"
                            placeholder="请输入英文"
                        />
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="userForm.name" maxlength="100" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.trim="userForm.phone" maxlength="11" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model.trim="userForm.password" show-password />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch v-model="userStatusSwitch" active-text="正常" inactive-text="停用" />
                    </el-form-item>
                </template>
                <!-- 新增 + 外勤专员：服务城市 → 合作外勤 → 登录名 → … -->
                <template v-else-if="isFieldSpecialistCreate">
                    <el-form-item label="服务城市" prop="serviceCity" required>
                        <el-input
                            v-model.trim="userForm.serviceCity"
                            maxlength="64"
                            show-word-limit
                            placeholder="请输入主要服务城市名称"
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="合作外勤" prop="fieldPartnerName" required>
                        <el-input
                            v-model.trim="userForm.fieldPartnerName"
                            maxlength="64"
                            show-word-limit
                            placeholder="请输入合作外勤名称"
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="登录名" prop="username">
                        <el-input
                            v-model.trim="userForm.username"
                            maxlength="50"
                            placeholder="请输入英文"
                        />
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="userForm.name" maxlength="100" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.trim="userForm.phone" maxlength="11" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model.trim="userForm.password" show-password />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch v-model="userStatusSwitch" active-text="正常" inactive-text="停用" />
                    </el-form-item>
                </template>
                <!-- 新增 + 外派专员：外派员 → 登录名 → 姓名 → … -->
                <template v-else-if="isDispatchSpecialistCreate">
                    <el-form-item label="外派员" prop="dispatchAgentName" required>
                        <el-input
                            v-model.trim="userForm.dispatchAgentName"
                            maxlength="100"
                            show-word-limit
                            placeholder="请输入外派员"
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="登录名" prop="username">
                        <el-input
                            v-model.trim="userForm.username"
                            maxlength="50"
                            placeholder="请输入英文"
                        />
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="userForm.name" maxlength="100" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.trim="userForm.phone" maxlength="11" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model.trim="userForm.password" show-password />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch v-model="userStatusSwitch" active-text="正常" inactive-text="停用" />
                    </el-form-item>
                </template>
                <!-- 新增 + 未选角色（占位，避免空白） -->
                <template v-else-if="!editingUserId">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="userForm.name" maxlength="100" />
                    </el-form-item>
                    <el-form-item label="登录名" prop="username">
                        <el-input v-model.trim="userForm.username" maxlength="50" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.trim="userForm.phone" maxlength="11" />
                    </el-form-item>
                    <el-form-item label="登录密码" prop="password">
                        <el-input v-model.trim="userForm.password" show-password />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch v-model="userStatusSwitch" active-text="正常" inactive-text="停用" />
                    </el-form-item>
                </template>
                <!-- 编辑子账号 -->
                <template v-else>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.trim="userForm.name" maxlength="100" />
                    </el-form-item>
                    <el-form-item label="登录名" prop="username">
                        <el-input v-model.trim="userForm.username" disabled maxlength="50" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.trim="userForm.phone" maxlength="11" />
                    </el-form-item>
                    <el-form-item label="重置密码" prop="password">
                        <el-input v-model.trim="userForm.password" show-password />
                        <div class="settings-users-page__field-tip">留空表示不修改密码</div>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-switch v-model="userStatusSwitch" active-text="正常" inactive-text="停用" />
                    </el-form-item>
                </template>
            </el-form>
            <span slot="footer">
                <el-button @click="userDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="userSaving" @click="submitUserForm">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="修改超级管理员"
            :visible.sync="superAdminDialogVisible"
            width="480px"
            :close-on-click-modal="false"
            @closed="resetSuperAdminForm"
        >
            <el-form ref="superAdminFormRef" :model="superAdminForm" :rules="superAdminRules" label-width="100px" size="small">
                <el-form-item label="登录名">
                    <span class="settings-users-page__readonly-text">{{ superAdminForm.username }}</span>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model.trim="superAdminForm.phone" maxlength="11" placeholder="11位手机号" />
                </el-form-item>
                <el-form-item label="登录密码" prop="password">
                    <el-input v-model.trim="superAdminForm.password" type="password" show-password autocomplete="new-password" placeholder="留空表示不修改" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="superAdminDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="superAdminSaving" @click="submitSuperAdminForm">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="分配角色"
            :visible.sync="dialogVisible"
            width="480px"
            :close-on-click-modal="false"
            @closed="editingUser = null"
        >
            <div v-if="editingUser">用户：{{ editingUser.name }}（{{ editingUser.username }}）</div>
            <el-select
                v-model="selectedRoleIds"
                multiple
                placeholder="请选择角色"
                class="settings-users-page__role-select"
            >
                <el-option
                    v-for="r in roles"
                    :key="r.id"
                    :label="displayRoleName(r)"
                    :value="r.id"
                />
            </el-select>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="saveRoles">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SettingsUsers',
    props: {
        embedded: {
            type: Boolean,
            default: false
        },
        hideCreateButton: {
            type: Boolean,
            default: false
        },
        hideToolbar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        var self = this;
        return {
            loading: false,
            users: [],
            roles: [],
            roleTypeOptions: [
                { label: '渠道专员', value: 'channel-specialist' },
                { label: '外勤专员', value: 'field-specialist' },
                { label: '外派专员-仅税务', value: 'dispatch-specialist-tax' },
                { label: '外派专员-仅工商', value: 'dispatch-specialist-biz' },
                { label: '外派专员-税工', value: 'dispatch-specialist-both' }
            ],
            userDialogVisible: false,
            userSaving: false,
            editingUserId: null,
            userForm: {
                roleTypeCode: '',
                channelName: '',
                fieldPartnerName: '',
                serviceCity: '',
                dispatchAgentName: '',
                name: '',
                username: '',
                phone: '',
                password: '',
                status: 1
            },
            userRules: {
                fieldPartnerName: [
                    {
                        validator: function (rule, value, callback) {
                            if (self.editingUserId || self.userForm.roleTypeCode !== 'field-specialist') {
                                callback();
                                return;
                            }
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback(new Error('请填写合作外勤'));
                                return;
                            }
                            if (s.length > 64) {
                                callback(new Error('合作外勤名称不能超过64个字'));
                                return;
                            }
                            callback();
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                serviceCity: [
                    {
                        validator: function (rule, value, callback) {
                            if (self.editingUserId || self.userForm.roleTypeCode !== 'field-specialist') {
                                callback();
                                return;
                            }
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback(new Error('请填写服务城市'));
                                return;
                            }
                            if (s.length > 64) {
                                callback(new Error('服务城市不能超过64个字'));
                                return;
                            }
                            callback();
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                dispatchAgentName: [
                    {
                        validator: function (rule, value, callback) {
                            var dr = ['dispatch-specialist-tax', 'dispatch-specialist-biz', 'dispatch-specialist-both'];
                            if (self.editingUserId || dr.indexOf(self.userForm.roleTypeCode) < 0) {
                                callback();
                                return;
                            }
                            if (!value || !String(value).trim()) {
                                callback(new Error('请填写外派员'));
                                return;
                            }
                            callback();
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                channelName: [
                    {
                        validator: function (rule, value, callback) {
                            if (self.editingUserId || self.userForm.roleTypeCode !== 'channel-specialist') {
                                callback();
                                return;
                            }
                            if (!value || !String(value).trim()) {
                                callback(new Error('请输入渠道名称'));
                                return;
                            }
                            callback();
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                roleTypeCode: [
                    {
                        validator: function (rule, value, callback) {
                            if (self.editingUserId) {
                                callback();
                                return;
                            }
                            if (!value) {
                                callback(new Error('请选择角色类型'));
                                return;
                            }
                            callback();
                        },
                        trigger: ['change', 'blur']
                    }
                ],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                username: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                    {
                        validator: function (rule, value, callback) {
                            if (self.editingUserId) {
                                callback();
                                return;
                            }
                            if (
                                self.userForm.roleTypeCode !== 'channel-specialist' &&
                                self.userForm.roleTypeCode !== 'field-specialist' &&
                                ['dispatch-specialist-tax', 'dispatch-specialist-biz', 'dispatch-specialist-both'].indexOf(self.userForm.roleTypeCode) < 0
                            ) {
                                callback();
                                return;
                            }
                            var s = value != null ? String(value).trim() : '';
                            if (s && !/^[a-zA-Z0-9._@-]+$/.test(s)) {
                                callback(new Error('登录名请使用英文字母、数字及 ._@-'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ],
                phone: [
                    {
                        validator: function (rule, value, callback) {
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback();
                                return;
                            }
                            if (!/^1[3-9]\d{9}$/.test(s)) {
                                callback(new Error('请输入11位有效手机号（1开头）'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ]
            },
            dialogVisible: false,
            editingUser: null,
            selectedRoleIds: [],
            saving: false,
            superAdminDialogVisible: false,
            superAdminSaving: false,
            editingSuperAdmin: null,
            superAdminForm: {
                username: '',
                phone: '',
                password: ''
            },
            superAdminRules: {
                phone: [
                    {
                        validator: function (rule, value, callback) {
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback();
                                return;
                            }
                            if (!/^1[3-9]\d{9}$/.test(s)) {
                                callback(new Error('请输入11位有效手机号（1开头）'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ],
                password: [
                    {
                        validator: function (rule, value, callback) {
                            var s = value != null ? String(value).trim() : '';
                            if (s === '') {
                                callback();
                                return;
                            }
                            if (s.length < 6) {
                                callback(new Error('密码至少6位'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    computed: {
        userStatusSwitch: {
            get() {
                return Number(this.userForm.status) === 1;
            },
            set(value) {
                this.userForm.status = value ? 1 : 0;
            }
        },
        isChannelSpecialistCreate: function () {
            return !this.editingUserId && this.userForm.roleTypeCode === 'channel-specialist';
        },
        isFieldSpecialistCreate: function () {
            return !this.editingUserId && this.userForm.roleTypeCode === 'field-specialist';
        },
        isDispatchSpecialistCreate: function () {
            if (this.editingUserId) {
                return false;
            }
            var dr = this.dispatchRoleTypeCodes;
            return dr.indexOf(this.userForm.roleTypeCode) >= 0;
        },
        dispatchRoleTypeCodes: function () {
            return ['dispatch-specialist-tax', 'dispatch-specialist-biz', 'dispatch-specialist-both'];
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        openCreateDialog() {
            this.editingUserId = null;
            this.userDialogVisible = true;
        },
        onRoleTypeCodeChange: function () {
            var vm = this;
            if (this.userForm.roleTypeCode !== 'channel-specialist') {
                this.userForm.channelName = '';
            }
            if (this.userForm.roleTypeCode !== 'field-specialist') {
                this.userForm.fieldPartnerName = '';
                this.userForm.serviceCity = '';
            }
            if (this.dispatchRoleTypeCodes.indexOf(this.userForm.roleTypeCode) < 0) {
                this.userForm.dispatchAgentName = '';
            }
            if (this.$refs.userFormRef) {
                this.$nextTick(function () {
                    vm.$refs.userFormRef.clearValidate(['channelName', 'fieldPartnerName', 'serviceCity', 'dispatchAgentName', 'username']);
                });
            }
        },
        openEditDialog(user) {
            this.editingUserId = user.id;
            this.userForm = {
                roleTypeCode: '',
                channelName: '',
                fieldPartnerName: '',
                serviceCity: '',
                dispatchAgentName: user.dispatch_agent_name != null ? String(user.dispatch_agent_name) : '',
                name: user.name || '',
                username: user.username || '',
                phone: user.phone || '',
                password: '',
                status: Number(user.status) === 1 ? 1 : 0
            };
            this.userDialogVisible = true;
        },
        openSuperAdminEditDialog(user) {
            this.editingSuperAdmin = user;
            this.superAdminForm = {
                username: user.username || '',
                phone: user.phone || '',
                password: ''
            };
            this.superAdminDialogVisible = true;
        },
        resetSuperAdminForm() {
            this.editingSuperAdmin = null;
            this.superAdminForm = {
                username: '',
                phone: '',
                password: ''
            };
            if (this.$refs.superAdminFormRef) {
                this.$refs.superAdminFormRef.clearValidate();
            }
        },
        submitSuperAdminForm() {
            var _this = this;
            if (!this.$refs.superAdminFormRef || !this.editingSuperAdmin) {
                return;
            }
            this.$refs.superAdminFormRef.validate(function (valid) {
                if (!valid) {
                    return;
                }
                var pwd = _this.superAdminForm.password != null ? String(_this.superAdminForm.password).trim() : '';
                if (pwd !== '' && pwd.length < 6) {
                    _this.$message.warning('登录密码至少6位');
                    return;
                }
                var phoneTrim = (_this.superAdminForm.phone || '').trim();
                var payload = {
                    phone: phoneTrim === '' ? null : phoneTrim
                };
                if (pwd !== '') {
                    payload.password = pwd;
                }
                _this.superAdminSaving = true;
                window.axios.put('/users/' + _this.editingSuperAdmin.id, payload).then(function () {
                    _this.$message.success('已保存');
                    _this.superAdminDialogVisible = false;
                    _this.fetchData();
                }).catch(function (error) {
                    var data = error && error.response && error.response.data ? error.response.data : {};
                    var message = data.message ? String(data.message) : '保存失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.superAdminSaving = false;
                });
            });
        },
        resetUserForm() {
            this.editingUserId = null;
            this.userForm = {
                roleTypeCode: '',
                channelName: '',
                fieldPartnerName: '',
                serviceCity: '',
                dispatchAgentName: '',
                name: '',
                username: '',
                phone: '',
                password: '',
                status: 1
            };
            if (this.$refs.userFormRef) {
                this.$refs.userFormRef.clearValidate();
            }
        },
        submitUserForm() {
            var _this = this;
            if (!this.$refs.userFormRef) {
                return;
            }
            this.$refs.userFormRef.validate(function (valid) {
                if (!valid) {
                    return;
                }
                var payload = {
                    name: _this.userForm.name,
                    phone: _this.userForm.phone || null,
                    status: Number(_this.userForm.status) === 1 ? 1 : 0
                };
                if (!_this.editingUserId) {
                    payload.username = _this.userForm.username;
                    payload.password = _this.userForm.password || '';
                    if (!payload.password || String(payload.password).length < 6) {
                        _this.$message.warning('新增账号密码至少6位');
                        return;
                    }
                    var role = (_this.roles || []).find(function (r) {
                        return r.code === _this.userForm.roleTypeCode;
                    });
                    if (!role) {
                        _this.$message.warning('未找到对应角色，请刷新页面后重试');
                        return;
                    }
                    payload.role_ids = [role.id];
                    if (_this.userForm.roleTypeCode === 'channel-specialist') {
                        payload.channel_name = (_this.userForm.channelName || '').trim();
                    }
                    if (_this.userForm.roleTypeCode === 'field-specialist') {
                        payload.field_partner_name = (_this.userForm.fieldPartnerName || '').trim();
                        payload.field_partner_service_city = (_this.userForm.serviceCity || '').trim();
                    }
                    if (_this.dispatchRoleTypeCodes.indexOf(_this.userForm.roleTypeCode) >= 0) {
                        payload.dispatch_agent_name = (_this.userForm.dispatchAgentName || '').trim();
                    }
                } else if (_this.userForm.password && String(_this.userForm.password).length > 0) {
                    if (String(_this.userForm.password).length < 6) {
                        _this.$message.warning('重置密码至少6位');
                        return;
                    }
                    payload.password = _this.userForm.password;
                }

                _this.userSaving = true;
                var request = _this.editingUserId
                    ? window.axios.put('/users/' + _this.editingUserId, payload)
                    : window.axios.post('/users', payload);

                request.then(function () {
                    _this.$message.success(_this.editingUserId ? '子账号更新成功' : '子账号创建成功');
                    _this.userDialogVisible = false;
                    _this.fetchData();
                }).catch(function (error) {
                    var data = error && error.response && error.response.data ? error.response.data : {};
                    var message = data.message ? String(data.message) : '子账号保存失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.userSaving = false;
                });
            });
        },
        toggleUserStatus(user) {
            var _this = this;
            var nextStatus = Number(user.status) === 1 ? 0 : 1;
            var actionText = nextStatus === 1 ? '启用' : '停用';
            this.$confirm('确认' + actionText + '账号「' + user.name + '」吗？', '提示', {
                type: 'warning'
            }).then(function () {
                window.axios.put('/users/' + user.id, {
                    status: nextStatus
                }).then(function () {
                    _this.$message.success('账号' + actionText + '成功');
                    _this.fetchData();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '账号状态更新失败';
                    _this.$message.error(message);
                });
            }).catch(function () {
            });
        },
        removeUser(user) {
            var _this = this;
            this.$confirm('确认删除子账号「' + user.name + '」吗？删除后不可恢复。', '删除确认', {
                type: 'warning'
            }).then(function () {
                return window.axios.delete('/users/' + user.id);
            }).then(function () {
                _this.$message.success('子账号已删除');
                _this.fetchData();
            }).catch(function (error) {
                if (error === 'cancel') {
                    return;
                }
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '删除失败';
                _this.$message.error(message);
            });
        },
        fetchData() {
            var _this = this;

            this.loading = true;
            Promise.all([
                window.axios.get('/users'),
                window.axios.get('/roles')
            ]).then(function (results) {
                _this.users = (results[0].data && results[0].data.data) || [];
                _this.roles = (results[1].data && results[1].data.data) || [];
            }).catch(function () {
                _this.$message.error('加载用户或角色失败，请确认账号具备相应权限');
            }).finally(function () {
                _this.loading = false;
            });
        },
        formatRoles(roles) {
            if (!roles || !roles.length) {
                return '--';
            }

            var _this = this;
            return roles.map(function (r) {
                return _this.displayRoleName(r);
            }).join('、');
        },
        displayRoleName(role) {
            if (!role) {
                return '';
            }
            if (String(role.code || '') === 'dispatch-specialist-both') {
                return '外派专员-税工';
            }
            return role.name || '';
        },
        openRoleDialog(user) {
            this.editingUser = user;
            this.selectedRoleIds = (user.roles || []).map(function (r) {
                return r.id;
            });
            this.dialogVisible = true;
        },
        saveRoles() {
            var _this = this;

            if (!this.editingUser) {
                return;
            }

            this.saving = true;
            window.axios.put('/users/' + this.editingUser.id + '/roles', {
                role_ids: this.selectedRoleIds
            }).then(function () {
                _this.$message.success('角色已更新');
                _this.dialogVisible = false;
                _this.fetchData();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.settings-users-page {
    padding: 0;
}

.settings-users-page--embedded {
    padding: 0;
}

.settings-users-page__heading {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.settings-users-page__toolbar {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.settings-users-page__card {
    border: 0;
}

.settings-users-page__role-select {
    width: 100%;
    margin-top: 16px;
}

.settings-users-page__field-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
}

.settings-users-page__readonly-text {
    color: #606266;
}

.settings-users-page__danger {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsUsers.vue